import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M15.914 14.517a1 1 0 0 0 1.415 0l2.233-2.234a5.45 5.45 0 0 0-.052-7.763 5.536 5.536 0 0 0-3.876-1.612 5.405 5.405 0 0 0-3.876 1.571L9.524 6.712a1 1 0 0 0 1.415 1.415l2.233-2.234a3.405 3.405 0 0 1 2.448-.985A3.536 3.536 0 0 1 18.1 5.94l.011.01a3.45 3.45 0 0 1 .036 4.919l-2.234 2.233a1 1 0 0 0 0 1.415ZM13.062 15.9l-2.234 2.233c-.64.64-1.49.992-2.448.985a3.451 3.451 0 0 1-2.492-1.07 3.45 3.45 0 0 1-.036-4.918l2.234-2.233A1 1 0 0 0 6.67 9.483l-2.233 2.234a5.451 5.451 0 0 0 .047 7.758 5.451 5.451 0 0 0 3.88 1.644c1.483.01 2.85-.543 3.877-1.57l2.234-2.234a1 1 0 0 0-1.414-1.414Zm-5.156.133a1 1 0 0 0 1.414 0l6.7-6.7a1 1 0 0 0-1.414-1.414l-6.7 6.7a1 1 0 0 0 0 1.414Z"
  />,
  'LinkAngled'
)
